import * as React from 'react';
import { toastr } from "react-redux-toastr";
import { IETLLog, initialETLLogs, initialRekognitionLogs, IRekLog, IServiceStatusRequest } from 'src/share/types/serviceStatus';
import { ServiceStatus } from 'src/share/services/serviceStatus';
import { ILastProcessedProps } from '../component/lastProcessed.types';

const { useState, useEffect } = React;
export const useServiceStatusLogs = (props: ILastProcessedProps) => {
  const [data, setData] = useState<Array<IETLLog | IRekLog>>([]);
  const [searchLogs, setSearchLogs] = React.useState(props.mode === 'rek' ? initialRekognitionLogs : initialETLLogs);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState(0);
  const loadETLLogs = async () => {
    try {
      setLoading(true);
      const { results, total: count } = await ServiceStatus.getLogs(searchLogs, props.mode);
      setData(results);
      setTotal(count);
      setLoading(false);
    } catch {
      toastr.error("Error", "There was a problem loading the logs information");
      setLoading(false);
    }
  }
  const handleSort = (column, sortDirection): void => {
    setSearchLogs(prevSearch => ({ ...prevSearch, sort: [{ [column.selector]: sortDirection }] }));
  }
  useEffect(() => {
    loadETLLogs();
  }, [searchLogs]);
  return [{ data, isLoading, total }, { setSearchLogs, handleSort }] as returned;
}

type returned = [IServiceStatusLogsState, { setSearchLogs: React.Dispatch<React.SetStateAction<IServiceStatusRequest>>, handleSort: (column: any, sortDirection: any) => void }];

interface IServiceStatusLogsState {
  data: IETLLog[];
  isLoading: boolean;
  total: number;
}
